{
  "it": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Aggiungi un responsabile",
        "bulk_remove": "Rimuovi",
        "confirm": "Contrassegna come completata",
        "delete": "Elimina responsabile",
        "document_add": "Aggiungi file",
        "document_delete": "Elimina",
        "due_in_month": "Tra un mese",
        "due_in_two_weeks": "Tra due settimane",
        "due_in_week": "Tra una settimana",
        "due_remove": "Rimuovi scadenza",
        "open": "Apri",
        "reopen": "Riapri",
        "selectAll": "Seleziona tutte ({total})",
        "send_and_notify": "Invia e notifica",
        "set_due_date": "Imposta scadenza",
        "set_status": "Imposta stato",
        "show_more": "Mostra {count} altra attività aperta | Mostra altre {count} attività aperte",
        "show_more_completed": "Mostra {count} altra attività completata | Mostra altre {count} attività completate",
        "unSelectAll": "Deseleziona tutto",
        "upload_files": "Carica {count} file | Carica {count} file"
      },
      "assignee_scopes": {
        "external": "Esterno",
        "internal": "Interno"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Membro del team",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Responsabile",
        "assignees": "Responsabili",
        "comment": "Commento",
        "created_at": "Creato",
        "document": "Documento",
        "due_date": "Scadenza",
        "project": "Progetto",
        "status": "Stato",
        "task": "Attività",
        "unit": "Unità"
      },
      "confirm": {
        "assignees_count": "{count} responsabile | {count} responsabili",
        "bulk_delete_accept": "Rimuovi",
        "bulk_delete_body": "Questo rimuove la loro attività per quelle unità. L'attività stessa e gli altri responsabili mantengono la propria.",
        "bulk_delete_body_project": "Questo rimuove la loro attività. L'attività stessa e gli altri responsabili mantengono la propria.",
        "bulk_delete_header": "Rimuovere {count} responsabile? | Rimuovere {count} responsabili?",
        "complete_accept": "Completa tutto",
        "complete_body": "Questo imposta {assignees} su {status}, anche le attività che il cliente non ha ancora completato. Passano alle attività completate del loro elenco.",
        "complete_header": "Segnare tutto come completato?",
        "customer_tasks": "{count} attività per i clienti | {count} attività per i clienti",
        "customers_and_team": "{customers} e {team}",
        "delete_body": "Questo rimuove la loro attività per quell'unità. Le altre unità e gli altri responsabili mantengono la propria.",
        "delete_body_project": "Questo rimuove la loro attività. Gli altri responsabili mantengono la propria.",
        "delete_header": "Rimuovere {name} da {unit}?",
        "delete_header_project": "Rimuovere {name} da questa attività?",
        "delete_sent_customers": "Questa era già stata inviata, quindi scompare anche dal portale dei clienti.",
        "delete_sent_team": "Questa era già stata inviata, quindi scompare anche dalla lista di {name}.",
        "document_delete_body": "Il file scompare anche dai documenti dell'unità.",
        "document_delete_body_project": "Il file scompare anche dai documenti del progetto.",
        "document_delete_header": "Eliminare questo file?",
        "draft_accept": "Riporta tutto in bozza",
        "draft_body": "Questo riporta {assignees} in {status}. L'attività sparisce dall'elenco del cliente finché non la invii di nuovo. Le e-mail già partite restano inviate.",
        "draft_header": "Riportare tutto in bozza?",
        "send_body": "Questo imposta {who} su {status}.",
        "send_customers": "I clienti vedono subito l'attività nel loro portale e ricevono un'e-mail al riguardo.",
        "send_header": "Inviare questa attività? | Inviare queste attività?",
        "send_permanent": "Puoi riportarle in Bozza più tardi, ma la notifica sarà già partita.",
        "send_team": "I membri del team vedono l'attività nella loro dashboard e ricevono una notifica.",
        "tasks_count": "{count} attività | {count} attività",
        "team_tasks": "{count} attività per il team | {count} attività per il team"
      },
      "deep_link": {
        "completed": "Questo compito è già completato.",
        "gone": "Questo compito non è più aperto."
      },
      "empty": {
        "filtered_description": "Modifica i tuoi filtri o cancellali per vedere tutte le assegnazioni.",
        "filtered_title": "Nessuna assegnazione corrisponde ai tuoi filtri",
        "none_title": "Nessuna assegnazione"
      },
      "filters": {
        "assignee_any": "Qualsiasi responsabile",
        "clear_all": "Svuota tutti i filtri",
        "done": "Fatto",
        "due_window_values": {
          "none": "Nessuna scadenza",
          "overdue": "In ritardo",
          "set": "Con scadenza"
        },
        "phase_any": "Qualsiasi fase",
        "show_only": "Mostra solo",
        "show_only_values": {
          "customers": "Clienti",
          "mine": "Assegnate a me",
          "team": "Team"
        },
        "unit_any": "Qualsiasi unità"
      },
      "labels": {
        "add_assignee": "Aggiungi un responsabile",
        "add_customers": "Aggiungi clienti",
        "already_assigned": "Questa attività è già stata aggiunta a questa unità.",
        "already_assigned_project": "Questa attività è già stata aggiunta a questo progetto.",
        "assignees_subtitle": "Ognuno riceve la propria attività, per unità.",
        "assignees_title": "Chi deve farlo",
        "comment_add": "Aggiungi un commento",
        "comment_earlier_round": "turno precedente",
        "comment_placeholder": "C'è qualcosa che dovremmo sapere?",
        "comment_placeholder_upload": "C'è qualcosa che dovremmo sapere su questi documenti?",
        "comments_none": "Il cliente non ha lasciato alcun commento.",
        "comments_title": "Commenti su questa attività",
        "completed": "Completata",
        "confirm_message": "È sicuro di voler contrassegnare questa attività come completata?",
        "customers": "Clienti",
        "documents_none": "Non è stato ancora caricato nulla.",
        "documents_title": "File di questo compito",
        "earlier": "+{count} precedenti",
        "my_tasks": "Le mie attività",
        "no_assignees": "Ancora nessun responsabile assegnato.",
        "no_assignments": "Le attività assegnate a te compaiono qui.",
        "no_assignments_task": "Ancora nessuna assegnazione per questa attività.",
        "previous_upload": "Caricamento precedente",
        "required": "Questo campo è obbligatorio",
        "section_completed": "Completate",
        "section_open": "Aperte",
        "selectOne": "Seleziona almeno un'attività.",
        "select_task": "Selezioni un'attività",
        "selected": "{selected} selezionata | {selected} selezionate",
        "set_status_for": "Imposta lo stato di {name}",
        "status_hint_assignees": "l'assegnatario | gli assegnatari",
        "status_hint_customer": "il cliente",
        "status_hint_sent": "gli assegnatari a cui è stata inviata",
        "superseded": "Sostituito",
        "totalSelected": "Tutte le {total} selezionate",
        "upload_hint": "Carichi i documenti richiesti per completare questa attività."
      },
      "status_hints": {
        "completed": "L'attività è completata. Resta visibile per {who}, in {completed}.",
        "draft": "Non ancora visibile per {who}. Imposta l'attività su {open} per condividerla.",
        "requested": "Visibile per {who}. L'attività deve ancora essere completata."
      },
      "statuses": {
        "completed": "Completata",
        "draft": "Bozza",
        "requested": "Aperta"
      },
      "toasts": {
        "bulk_delete": "Attività rimosse",
        "bulk_update": "Attività aggiornate",
        "completed": "Attività completata",
        "create": "Attività creata",
        "delete": "Responsabile eliminato",
        "document_added": "File aggiunto",
        "document_deleted": "File eliminato",
        "reopened": "Attività riaperta",
        "update": "Attività aggiornata"
      }
    }
  }
}
